<template>
  <AppHead :title="title" :description="description" :image="image" />
  <ConfigProvider :dir="useDirectionStore.getDirection">
    <slot />
  </ConfigProvider>
</template>

<script setup>
import AppHead from "@/Components/AppHead.vue";
import { ConfigProvider } from "radix-vue";
import { directionStore } from "@/Stores/direction";

const useDirectionStore = directionStore();

defineProps({
  title: {
    type: String,
  },
  description: {
    type: String,
  },
  image: {
    type: String,
  },
});
</script>
